import { IDispatcherService, IDispatcher } from '../';
import { IValueViewModel } from '../../models';
import { IValueViewModelActionsService } from './valueViewModels.actionCreator';

export interface IValueViewModelStoreService {
    getAll: (force?: boolean) => angular.IPromise<IValueViewModel[]>;
    // get: (guids: string[], force?: boolean) => angular.IPromise<IValueViewModel[]>;
    getOne: (guid: string, force?: boolean) => angular.IPromise<IValueViewModel>;
}

export interface IValueViewModelActionDispatcherService extends IDispatcherService<IValueViewModelStoreService> { }

export class ValueViewModelActionDispatcherService implements IValueViewModelActionDispatcherService {
    static serviceId = 'valueViewModelActionDispatcherService';

    static $inject = ['valueViewModelActionsService'];

    constructor(private _vvmActionService: IValueViewModelActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IValueViewModelStoreService> {
        const vvmService = this._vvmActionService;

        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(vvmService.getAll(force)),
                // get: (guids: string[], force?: boolean) => dispatch(vvmService.get(guids, force)),
                getOne: (guid: string, force?: boolean) => dispatch(vvmService.getOne(guid, force))
            }
        };
    }
}
